import { cn } from "@/lib/utils";

export const BillingToggle = ({ yearly, onChange, className, size = "md", pct = 0 }) => (
  <div className={cn("inline-flex items-center rounded-full border border-[#27272A] bg-[#09090B] p-1", size === "sm" ? "text-[11px]" : "text-sm", className)} role="group" data-testid="billing-toggle">
    {[[false, "Monthly"], [true, "Yearly"]].map(([v, l]) => (
      <button key={l} onClick={() => onChange(v)} data-testid={`billing-toggle-${v ? "yearly" : "monthly"}`} aria-pressed={yearly === v}
        className={cn("flex items-center gap-1.5 rounded-full transition-colors", size === "sm" ? "px-3 py-1" : "px-4 py-1.5", yearly === v ? "bg-[#D4AF37] font-semibold text-black" : "text-zinc-400 hover:text-zinc-200")}>
        {l}{v && pct > 0 && <span data-testid="billing-toggle-save" className={cn("rounded-full px-1.5 text-[9px] font-bold", yearly ? "bg-black/15 text-black" : "bg-[#33290D] text-[#F3C649]")}>-{pct}%</span>}
      </button>
    ))}
  </div>
);
